import { Box, Card, CardContent, Typography } from '@mui/material'
import React from 'react'
import { LIONS_CLUB_CAP } from '../constants'

import lionImage from '../assets/LionLogo_V01-01.png'
import { blue } from '@mui/material/colors'

const WIDTH = 100

const LionsClubCard = ({ count }) => {
  return (
    <Card sx={{ mb: 2 }}>
      <CardContent sx={{ textAlign: 'center' }}>
        <LionsClubCardContent count={count} />
      </CardContent>
    </Card>
  )
}

const LionsClubCardContent = ({ count, isMobile }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        ...(isMobile
          ? { border: `2px solid ${blue[600]}`, borderRadius: '3px', p: 1 }
          : {}),
      }}
    >
      <Box sx={{ width: `${WIDTH}px`, mr: 2 }}>
        <img style={{ width: `${WIDTH}px` }} src={lionImage}></img>
      </Box>
      <Box>
        <Typography sx={{ fontSize: '18px', textAlign: 'left', mb: 1 }}>
          <b>
            Certified #{count} of the first {LIONS_CLUB_CAP} users
          </b>
        </Typography>
        <Typography sx={{ fontSize: '16px', textAlign: 'left' }}>
          Member of The Grand Lions Round Table
        </Typography>
      </Box>
    </Box>
  )
}

export { LionsClubCardContent }

export default LionsClubCard
